/* eslint-disable */
import auth from "./js/auth";
import Vue from "vue";
import Router from "vue-router";
import AdminApplicants from './views/Admin/Applicants.vue';
import AdminDashboard from './views/Admin/Dashboard.vue';
import AdminHome from './views/Admin/Home.vue';
import AdminPermissions from './views/Admin/Permissions.vue';
import AdminReleaseOfInformation from './views/Admin/Forms/ReleaseOfInformation.vue';
import AdminReports from './views/Admin/Reports.vue';
import AdminResidenceAssistantManager from './views/Admin/ResidenceAssistantManager.vue';
import AdminStatistics from './views/Admin/Statistics.vue';
import AdminMatcher from './views/Admin/RommateMatcher.vue';
import AdminSystemConfigurationAnnouncements from './views/Admin/SystemConfiguration/Announcements.vue';
import AdminSystemConfigurationBuildings from './views/Admin/SystemConfiguration/Buildings.vue';
import AdminSystemConfigurationMealPlans from './views/Admin/SystemConfiguration/MealPlans.vue';
import AdminSystemConfigurationRegisteredAt from './views/Admin/SystemConfiguration/RegisteredAt.vue';
import AdminSystemConfigurationResidenceTerms from './views/Admin/SystemConfiguration/ResidenceTerms.vue';
import AdminSystemConfigurationYearOfStudy from './views/Admin/SystemConfiguration/YearOfStudy.vue';
import App from './views/App/App.vue';
import Unauthenticated from './views/Unauthenticated/Unauthenticated.vue';
import Unauthorized from './views/Unauthorized/Unauthorized.vue';
import ParentApproval from './views/Public/ParentApproval.vue';
import StudentDashboard from './views/Student/Dashboard.vue';
import StudentHome from './views/Student/Home.vue';
import StudentMyApplications from './views/Student/MyApplications.vue';
import StudentOnlineResidenceApplication from './views/Student/OnlineResidenceApplication.vue';
import StudentReleaseOfInformation from './views/Student/ReleaseOfInformation.vue';

Vue.use(Router);

const routes = [{
        path: "*",
        beforeEnter: redirect
    },
    {
        path: "/",
        name: "",
        alias: '/',
        component: App,
        children: [{
                path: '/',
                name: "admin-dashboard",
                alias: '/',
                component: AdminDashboard,
                children: [{
                        path: '',
                        name: 'home',
                        alias: '',
                        component: AdminHome
                    },
                    {
                        path: '/applicants',
                        name: 'adminapplicants',
                        alias: '/applicants',
                        component: AdminApplicants,
                        beforeEnter: checkPermission
                    },
                    {
                        path: '/applicants/:id',
                        name: 'applicants',
                        alias: '/applicants',
                        component: AdminApplicants,
                        props: true,
                        beforeEnter: checkPermission
                    },
                    {
                        path: '/forms/release-of-information',
                        name: 'adminapplicants',
                        alias: '/forms/release-of-information',
                        component: AdminReleaseOfInformation,
                        beforeEnter: checkPermission
                    },
                    {
                        path: '/forms/release-of-information/:username',
                        name: 'adminapplicants',
                        alias: '/forms/release-of-information',
                        component: AdminReleaseOfInformation,
                        props: true,
                        beforeEnter: checkPermission
                    },
                    {
                        path: '/permissions',
                        name: 'adminpermissions',
                        alias: '/permissions',
                        component: AdminPermissions,
                        beforeEnter: checkPermission
                    },
                    {
                        path: '/reports',
                        name: 'adminreports',
                        alias: '/reports',
                        component: AdminReports,
                        beforeEnter: checkPermission
                    },
                    {
                        path: '/residence-assistant-manager',
                        name: 'adminresidenceassistantmanager',
                        alias: '/residence-assistant-manager',
                        component: AdminResidenceAssistantManager,
                        beforeEnter: checkPermission
                    },
                    {
                        path: '/statistics',
                        name: 'adminstatistics',
                        alias: '/statistics',
                        component: AdminStatistics,
                        beforeEnter: checkPermission

                    },
                    {
                        path: '/pairingnplacement',
                        name: 'adminroommatematcher',
                        alias: '/pairingnplacement',
                        component: AdminMatcher,
                        beforeEnter: checkPermission

                    },
                    {
                        path: '/system-configuration/announcements',
                        name: 'adminsystemconfiguration',
                        alias: '/system-configuration/announcements',
                        component: AdminSystemConfigurationAnnouncements,
                        beforeEnter: checkPermission
                    },
                    {
                        path: '/system-configuration/buildings',
                        name: 'adminsystemconfiguration',
                        alias: '/system-configuration/buildings',
                        component: AdminSystemConfigurationBuildings,
                        beforeEnter: checkPermission
                    },
                    {
                        path: '/system-configuration/meal-plans',
                        name: 'adminsystemconfiguration',
                        alias: '/system-configuration/meal-plans',
                        component: AdminSystemConfigurationMealPlans,
                        beforeEnter: checkPermission
                    }, {
                        path: '/system-configuration/registered-at',
                        name: 'adminsystemconfiguration',
                        alias: '/system-configuration/registered-at',
                        component: AdminSystemConfigurationRegisteredAt,
                        beforeEnter: checkPermission
                    }, {
                        path: '/system-configuration/residence-terms',
                        name: 'adminsystemconfiguration',
                        alias: '/system-configuration/residence-terms',
                        component: AdminSystemConfigurationResidenceTerms,
                        beforeEnter: checkPermission
                    }, {
                        path: '/system-configuration/year-of-study',
                        name: 'adminsystemconfiguration',
                        alias: '/system-configuration/year-of-study',
                        component: AdminSystemConfigurationYearOfStudy,
                        beforeEnter: checkPermission
                    },
                ],
                beforeEnter: checkAdmin
            },
            {
                path: '/student',
                name: "student-dashboard",
                alias: '/student',
                component: StudentDashboard,
                children: [{
                        path: '',
                        name: 'home',
                        alias: '',
                        component: StudentHome
                    },
                    {
                        path: '/my-applications',
                        name: 'my-applications',
                        alias: '/my-applications',
                        component: StudentMyApplications
                    },
                    {
                        path: '/my-applications/:id',
                        name: 'my-applications',
                        alias: '/my-applications',
                        component: StudentMyApplications,
                        props: true
                    },
                    {
                        path: '/online-residence-application',
                        name: 'online-residence-application',
                        alias: '/online-residence-application',
                        component: StudentOnlineResidenceApplication
                    },
                    {
                        path: '/release-of-information',
                        name: 'release-of-information',
                        alias: '/release-of-information',
                        component: StudentReleaseOfInformation
                    }
                ],
                beforeEnter: checkStudent
            }
        ],
        beforeEnter: requireAuth
    },
    {
        path: '/parent-approval',
        name: 'parent-approval',
        alias: '/parent-approval',
        component: ParentApproval,
    },
    {
        path: '/parent-approval/:id',
        name: 'parent-approval',
        alias: '/parent-approval',
        component: ParentApproval,
        props: true
    },
    {
        path: "/unauthenticated",
        name: "unauthenticated",
        alias: '/unauthenticated',
        component: Unauthenticated,
        beforeEnter: checkAuthentication
    },
    {
        path: "/unauthorized",
        name: "unauthorized",
        alias: '/unauthorized',
        component: Unauthorized,
        beforeEnter: checkAuthorization
    }
];

function checkAdmin(to, from, next) {
    // Check if the user is an admin
    if (auth.isAdmin()) {
        // Redirect to admin dashboard
        next();
    } else {
        // Otherwise redirect to user dashboard
        next({
            path: '/student'
        })
    }
}

function checkAuthentication(to, from, next) {
    // Authenticate user if mkvn cookie exists
    auth.authenticated().then(function (response) {
            if (response) {
                // Redirect to app if authenticated
                next({
                    path: '/'
                })
            } else {
                // Check if user is unauthorized
                if (!auth.authorized()) {
                    next({
                        path: '/unauthorized'
                    })
                } else {
                    // Redirect to unauthenticated view
                    next();
                }
            }
        })
        .catch(function () {
            // Redirect to unauthenticated view
            next();
        })
}

function checkAuthorization(to, from, next) {
    // Authenticate user if mkvn cookie exists
    auth.authenticated().then(function (response) {
            if (response) {
                // Redirect to app if authenticated
                next({
                    path: '/'
                })
            } else {
                // Check if user is unauthorized
                if (!auth.authorized()) {
                    // Redirect to unauthorized view
                    next();
                } else {
                    // Redirect to unauthenticated view
                    next({
                        path: '/unauthenticated'
                    })
                }
            }
        })
        .catch(function () {
            // Redirect to unauthenticated view
            next({
                path: '/unauthenticated'
            })
        })
}

function checkPermission(to, from, next) {
    // Check if user has permission
    if (auth.hasPermission(to.name)) {
        // Redirect to path
        next();
    } else {
        // Otherwise redirect to home dashboard
        next({
            path: '/'
        })
    }
}

function checkStudent(to, from, next) {
    // Check if the user is not an admin
    if (!auth.isAdmin()) {
        // Redirect to student dashboard
        next();
    } else {
        // Otherwise redirect to admin dashboard
        next({
            path: '/admin'
        })
    }
}

function redirect(to, from, next) {
    // Redirect all paths to unauthenticated check
    next({
        path: '/unauthenticated'
    });
}

function requireAuth(to, from, next) {
    // Check if user is authenticated
    auth.authenticated().then(function (response) {
        if (response) {
            // Navigate to specified view if authenticated
            next();
        } else {
            // Redirect to unauthenticated view
            next({
                path: '/unauthenticated'
            })
        }
    }).catch(function () {
        // Redirect to unauthenticated view
        next({
            path: '/unauthenticated'
        })
    })
}

export default new Router({
    routes: routes
});